import { render, staticRenderFns } from "./DialogFeedback.vue?vue&type=template&id=c2d8fb66"
import script from "./DialogFeedback.vue?vue&type=script&lang=js"
export * from "./DialogFeedback.vue?vue&type=script&lang=js"
import style0 from "./DialogFeedback.vue?vue&type=style&index=0&id=c2d8fb66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports